export default {
    computed: {
        requiredFieldsConfig() {
            const settings = this.$store.state.settings || {}
            const rf = settings.requiredFields || {}
            // default true preserva el comportamiento actual mientras el backend
            // aún no entregue requiredFields (rollout escalonado backend/frontend)
            return {
                email: rf.email !== false,
                phone: rf.phone !== false,
                address: rf.address !== false,
                document: rf.identification !== false,
            }
        }
    }
}
